function ExpertiseController(){
	this.className			= "ExpertiseController";
	this.view				= false; //"example";
	this.glob				= ["/expertise**"];
	this.viewData			= {};
}
ExpertiseController.inheritsFrom( PageController );

ExpertiseController.prototype.on = function(onComplete){
	this.$body				= $('body');

	const revealer = new Revealer({
		//wrapperClass: 'js-expander',
		//contentClass: 'js-expander-content',
		//linkClass:    'js-expander-link'
	});
	revealer.run();

	/*
	// Expander
	this.$expander     = this.$body.find('.js-expander');
	this.$expanderLink = this.$expander.find('.js-expander-link');

	this.$expanderLink.on('click touchstart', (e) => {
		if(e.cancelable) e.preventDefault(); //touchstart can't call preventDefault
		const $expander = $(e.currentTarget).parents('.js-expander');
		this.expandContent($expander);
	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});
	*/

	return true;
}
/*
ExpertiseController.prototype.expandContent = function($elem) {
	const $expanderContent  = $elem.find('.js-expander-content');
	if (!$expanderContent.length) return;

	const isOpen = $elem.hasClass('expander--open');
	$elem.toggleClass('expander--open');

	const currentHeight  = $expanderContent[0].clientHeight;
	const revealerHeight = $expanderContent[0].scrollHeight;
	const newHeight      = isOpen ? 0 : revealerHeight;

	$expanderContent.stop().animate({height: `${newHeight}px`}, 800);
}
*/